import { render, staticRenderFns } from "./BookingPopoutInfo.vue?vue&type=template&id=c6e5f65a&scoped=true&"
import script from "./BookingPopoutInfo.vue?vue&type=script&lang=js&"
export * from "./BookingPopoutInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingPopoutInfo.vue?vue&type=style&index=0&id=c6e5f65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e5f65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCheckbox,VIcon})
